import * as React from "react";

export interface ConsentLinkSessionValue {
    token: string | null;
    consentId: string;
    allowedScopes: string[];
    loading: boolean;
    error: string | null;
    hasScope: (scope: string) => boolean;
    clear: () => void;
}

export const ConsentLinkSessionContext =
    React.createContext<ConsentLinkSessionValue | null>(null);
